import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMarkGreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 11,
	viewBox: "0 0 16 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.744 1.34242L15.2199 0.855514C15.0552 0.702397 14.8356 0.618164 14.6012 0.618164C14.3668 0.618164 14.1471 0.702397 13.9824 0.855514L6.61815 7.69709L2.01704 3.42237C1.85236 3.2695 1.63265 3.18515 1.39824 3.18515C1.16397 3.18515 0.94439 3.2695 0.779577 3.42237L0.25535 3.90916C0.0905366 4.06252 0 4.26676 0 4.48429C0 4.70194 0.0905366 4.90605 0.25535 5.05917L5.45028 9.88521C5.45717 9.89427 5.46446 9.90273 5.47291 9.91047L5.99714 10.3894C6.16182 10.5419 6.38153 10.6182 6.61776 10.6182H6.62049C6.85502 10.6182 7.07473 10.5419 7.23915 10.3894L7.76351 9.90624C7.77197 9.8985 7.77912 9.8921 7.78341 9.88557L15.7439 2.49074C16.0853 2.17423 16.0853 1.65929 15.744 1.34242Z",
		fill: "#1CB954"
	})
});
export default SvgCheckMarkGreen;
